var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bookGoodsModel.isGroupBuying)?_c('GroupBuyingMore',{class:_vm._.block,attrs:{"data":_vm.bookGoodsModel.marketingData.groupBuying,"no-rule":true},on:{"countdownend":_vm.handleCountdownEnd}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }